import { NavLink, useNavigate, Link } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';
import logo from '../../Images/GeoParkingLogo.png'; // Adjust the path as necessary
import PopUPModal from '../utils/Modal'
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/msalConfig";
import { silentRequest } from "../utils/msalConfigB2C.js";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import Cookies from 'js-cookie';
import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import { useMsalInstances } from "../utils/MsalInstancesContext";
import { Divider } from '@mui/joy';
import warniningIcon from '../../Images/warning.png'

const Navbar = ({ mapvisible, setMapvisible }) => {
    const navigate = useNavigate();
    const [showPopup1, setShowPopup1] = useState(false);
    const SESSION_TIMEOUT = 20 * 60 * 1000; // 20 minutes
    const WARNING_TIME = 60 * 1000; // Show popup for the last 60 seconds
    const [showPopup, setShowPopup] = useState(false);
    const [countdown, setCountdown] = useState(60);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);
    const envname = process.env.REACT_APP_ENV_TXT || null;
    const activityTimeoutRef = useRef(null);
    const countdownIntervalRef = useRef(null);
    const [tooltip] = useState({ show: false, text: "", position: { top: 0, left: 0 } });
    const [nextRoute, setNextRoute] = React.useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const {  } = useMsal();
    const { azureADInstance, b2cInstance } = useMsalInstances();
    const { userDetails } = useUser();
    const { initial } = useUser();
    const { empDetails, employeeData } = useUser();
    // const appVersion = process.env.REACT_APP_VERSION;

    useEffect(() => {
        const interval = setInterval(() => {
            acquireToken();
            acquireB2CToken();
        }, 50 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);
    const acquireToken = async () => {
        try {
            const accounts = azureADInstance.getAllAccounts();
            if (accounts.length === 0) throw new Error("No user is logged in.");
            const response = await azureADInstance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0], // Provide the account information
            });
            console.log("New access token acquired:", response);
            Cookies.set("idToken", response.idToken);
        } catch (error) {
            console.error("Token acquisition failed:", error);
            if (error instanceof InteractionRequiredAuthError) {
                const response = await azureADInstance.acquireTokenPopup(loginRequest);
                Cookies.set("idToken", response.idToken);
            }
        }
    };
    const acquireB2CToken = async () => {
        try {
            const accounts = b2cInstance.getAllAccounts();
            if (accounts.length === 0) throw new Error("No user is logged in.");

            const response = await b2cInstance.acquireTokenSilent({
                ...silentRequest,
                account: accounts[0], // Provide the account information
            });
            console.log("New access token acquired:", response);
            Cookies.set("idToken", response.accessToken);
        } catch (error) {
            console.error("Token acquisition failed:", error);
            if (error instanceof InteractionRequiredAuthError) {
                const response = await b2cInstance.acquireTokenPopup(silentRequest);
                Cookies.set("idToken", response.accessToken);
            }
        }
    };
    useEffect(() => {
        const resetActivityTimeout = () => {
            clearTimeout(activityTimeoutRef.current);
            activityTimeoutRef.current = setTimeout(() => {
                setShowPopup(true);
                startCountdown();
            }, SESSION_TIMEOUT - WARNING_TIME);
        };
        const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
        activityEvents.forEach(event =>
            window.addEventListener(event, resetActivityTimeout)
        );
        resetActivityTimeout();
        return () => {
            clearTimeout(activityTimeoutRef.current);
            clearInterval(countdownIntervalRef.current);
            activityEvents.forEach(event =>
                window.removeEventListener(event, resetActivityTimeout)
            );
        };
    }, []);

    const startCountdown = () => {
        countdownIntervalRef.current = setInterval(() => {
            setCountdown(prevCount => {
                const nextCount = prevCount - 1;
                if (nextCount === 0) {
                    clearInterval(countdownIntervalRef.current);
                    handleLogout();
                }
                return nextCount;
            });
        }, 1000);
    };

    const handleLogout = (e) => {
        e.preventDefault();
        setShowPopup(false);

        // Clear localStorage
        localStorage.clear();

        // Clear cookies
        document.cookie.split(";").forEach((cookie) => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
        });
        if (envname === "Engineering" || envname === "DEMO") {
            navigate("/");
        }
        else
            navigate('/login');
    };

    const handleStayLoggedIn = () => {
        setShowPopup(false);
        setCountdown(60);
        clearTimeout(activityTimeoutRef.current);
        clearInterval(countdownIntervalRef.current);
        activityTimeoutRef.current = setTimeout(() => {
            setShowPopup(true);
            startCountdown();
        }, SESSION_TIMEOUT - WARNING_TIME);
    };
    const handleConfirmNavigate = () => {
        setShowPopup1(false);
        if (nextRoute) {
            navigate(nextRoute);
            setNextRoute(null);
        }
    };

    const handleCancelNavigate = () => {
        setShowPopup1(false);
        setOpenDialog(false)
    };
    const handleConfirmNavigation = () => {
        setOpenDialog(false);
        setMapvisible(false);
        if (nextRoute) {
            navigate(nextRoute)
        }
    };

    const handleNavigation = (event, route) => {
        if (mapvisible) {
            event.preventDefault();
            setOpenDialog(true)
            setNextRoute(route);
        } else {
            navigate(route);
        }
    };
    return (
        <nav className="navbar">
            {/* Navbar logo and links */}
            <div className="navbar-logo">
                <img src={logo} alt="Logo" />
            </div>
            {envname && <span className="restricted-badge-navbar">{envname}</span>}
            <div className="navbar-links">
                {(empDetails || userDetails || employeeData) && (
                    <>
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) => (isActive ? 'selected' : '')}
                            onClick={(e) => handleNavigation(e, "/dashboard")}

                        >
                            Dashboard
                        </NavLink>

                        {userDetails && (!empDetails || !empDetails?.companyEmail?.includes('@geoparking.com')) && (
                            <>
                                <NavLink
                                    to="/viewparkinginfo"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/viewparkinginfo")}
                                >
                                    My Properties
                                </NavLink>
                                <NavLink
                                    to="/EmployeeRegistrationDashboard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/EmployeeRegistrationDashboard")}
                                >
                                    Employee Registration Dashboard
                                </NavLink>
                                <NavLink to="/earnings" className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/earnings")}
                                >
                                    Earnings
                                </NavLink>
                            </>
                        )}
                        {
                            employeeData && (!empDetails || !empDetails?.companyEmail?.includes('@geoparking.com')) && (
                                <>
                                    <NavLink
                                        to="/viewparkinginfo"
                                        className={({ isActive }) => (isActive ? 'selected' : '')}
                                        onClick={(e) => handleNavigation(e, "/viewparkinginfo")}
                                    >
                                        My Properties
                                    </NavLink>
                                </>
                            )
                        }

                        {empDetails?.companyEmail?.includes('@geoparking.com') && (
                            <>
                                <NavLink
                                    to="/reviewtab"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/reviewtab")}
                                >
                                    Pending Approval
                                </NavLink>
                                <NavLink
                                    to="/OwnerRegistrationDashboard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/OwnerRegistrationDashboard")}

                                >
                                    Owner & Property Management
                                </NavLink>
                                <NavLink
                                    to="/GlobalSearchDashBoard"
                                    className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/GlobalSearchDashBoard")}

                                >
                                    Global Search
                                </NavLink>
                                <NavLink to="/salesinsights" className={({ isActive }) => (isActive ? 'selected' : '')}
                                    onClick={(e) => handleNavigation(e, "/salesinsights")}

                                >
                                    Sales Insights
                                </NavLink>
                                {tooltip.show && (
                                    <div
                                        className="tooltip-custom"
                                        style={{
                                            top: tooltip.position.top,
                                            left: tooltip.position.left,
                                            transform: "translateX(-50%)",
                                        }}
                                    >
                                        {tooltip.text}
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            <div className="navbar-profile" onClick={toggleDropdown}>
                <div className="profile-icon">{initial}</div>
                {isDropdownVisible && (
                    <div className="dropdown-menu">
                        <ul>
                            {/* Show additional options only for non-internal employees */}
                            {empDetails?.companyEmail?.includes('@geoparking.com') ? (
                                <>
                                    <li>
                                        <a href="/login" onClick={handleLogout}>Logout</a>
                                    </li>
                                    <li>
                                        <NavLink
                                            to="/settings/pricing"
                                            className={({ isActive }) => (isActive ? 'selected' : '')}
                                        >
                                            Admin Settings

                                        </NavLink>

                                    </li>
                                    <li>
                                        {/* <span className="version">  Version.{process.env.REACT_APP_VERSION}</span> */}
                                    </li>


                                </>

                            ) : (
                                <>
                                    <li>
                                        <NavLink
                                            to="/settings/entity"
                                            className={({ isActive }) => (isActive ? 'selected' : '')}
                                        >
                                            Entity Information
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to="/settings/profile"
                                            className={({ isActive }) => (isActive ? 'selected' : '')}
                                        >
                                            Profile Information
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to="/settings/change-password"
                                            className={({ isActive }) => (isActive ? 'selected' : '')}
                                        >
                                            Change Password
                                        </NavLink>
                                    </li>

                                    <li>
                                        <a href="/login" onClick={handleLogout}>Logout</a>
                                    </li>
                                    <li>
                                   {/* <span className="version">  Version.{process.env.REACT_APP_VERSION}</span> */}
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                )}
            </div>
            {showPopup1 && (
                <div className="custom-popup">
                    <div className="popup-text">
                        <p>All unsaved progress will be lost. Are you sure you want to continue?</p>
                        <div className="popup-buttons">
                            <button className="confirm-btn" onClick={handleConfirmNavigate}>
                                Continue
                            </button>
                            <button className="cancel-btn" onClick={handleCancelNavigate}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showPopup && (
                <div className="custom-popup">
                    <div className="popup-text">
                        <p>Are you still there? You will be logged out in {countdown} seconds.</p>
                        <div className="popup-buttons">
                            <button className="confirm-btn" onClick={handleStayLoggedIn}>
                                Stay Logged In
                            </button>
                            <button className="cancel-btn" onClick={handleLogout}>
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {openDialog && (
                <>
                    <div className="custom-popup">
                        <div className="popup-text-warning">
                            <h3 className="popup-warning"><img src={warniningIcon} /> Warning!</h3>
                            <Divider
                                sx={{
                                    width: "100%",
                                    height: "2px",
                                    backgroundColor: "#8B8B8B",
                                    borderRadius: "1px",
                                    marginTop: "10px"
                                }}
                            />
                            <span style={{ padding: '25px' }}>{PopUPModal.Alert_dialog_description}</span>

                            <div className="popup-buttons">
                                <button className="confirm-btn" onClick={handleConfirmNavigation}>
                                    Continue
                                </button>
                                <button className="cancel-btn" onClick={handleCancelNavigate}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )
            }

        </nav >
    );
};

export default Navbar;
